export default __webpack_public_path__ + "media/images/icons/icon-logo-dffece2b47a6e2c2b75b57a680eb1e02.svg";